import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const api = axios.create({
  baseURL: API_URL
});

// Injection automatique du token JWT
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('sigepro_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Redirection automatique si token expiré
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const path = window.location.pathname;
    if (error.response?.status === 401 && path !== '/connexion' && path !== '/portail') {
      localStorage.removeItem('sigepro_token');
      localStorage.removeItem('sigepro_user');
      window.location.href = '/connexion';
    }
    return Promise.reject(error);
  }
);

// Auth
export const inscription = (data) => api.post('/auth/inscription', data);
export const connexion = (data) => api.post('/auth/connexion', data);
export const getMoi = () => api.get('/auth/moi');

// Projets
export const getProjets = () => api.get('/projets');
export const getProjet = (id) => api.get(`/projets/${id}`);
export const getSnapshot = (id) => api.get(`/projets/${id}/snapshot`);
export const creerProjet = (data) => api.post('/projets', data);
export const modifierProjet = (id, data) => api.put(`/projets/${id}`, data);
export const ouvrirIDE = (id, ide) => api.post(`/projets/${id}/open-ide`, { ide });

// Phases
export const getPhases = (projetId) => api.get(`/phases?projet_id=${projetId}`);
export const creerPhase = (data) => api.post('/phases', data);

// Sprints
export const getSprints = (phaseId) => api.get(`/sprints?phase_id=${phaseId}`);
export const creerSprint = (data) => api.post('/sprints', data);

// Tâches
export const getTaches = (sprintId) => api.get(`/taches?sprint_id=${sprintId}`);
export const creerTache = (data) => api.post('/taches', data);
export const modifierTache = (id, data) => api.put(`/taches/${id}`, data);
export const supprimerTache = (id) => api.delete(`/taches/${id}`);

// Documents — cache status & régénération
export const getDocsCacheStatus = (projetId) => api.get(`/projets/${projetId}/docs/cache-status`);
export const regenererDocs = (projetId) => api.post(`/projets/${projetId}/docs/regenerer`);

// Membres d'un projet
export const listerMembres = (projetId) => api.get(`/projets/${projetId}/membres`);
export const ajouterMembre = (projetId, data) => api.post(`/projets/${projetId}/membres`, data);
export const retirerMembre = (projetId, userId) => api.delete(`/projets/${projetId}/membres/${userId}`);

// Utilisateurs
export const listerUsers = () => api.get('/auth/users');
export const obtenirUser = (id) => api.get(`/auth/users/${id}`);
export const creerUser = (data) => api.post('/auth/inscription', data);
export const modifierUser = (id, data) => api.put(`/auth/users/${id}`, data);
export const changerPassword = (id, data) => api.put(`/auth/users/${id}/password`, data);
export const supprimerUser = (id) => api.delete(`/auth/users/${id}`);

// Contrats API Guardian
export const getContrats = (params) => api.get('/contracts', { params });
export const creerContrat = (data) => api.post('/contracts', data);
export const modifierContrat = (id, data) => api.patch(`/contracts/${id}`, data);
export const obtenirContrat = (id) => api.get(`/contracts/${id}`);
export const desactiverContrat = (id) => api.delete(`/contracts/${id}`);
export const statsContrats = () => api.get('/contracts/stats');
export const logsContrat = (id, params) => api.get(`/contracts/${id}/logs`, { params });
export const rapportContrat = (id) => api.get(`/contracts/${id}/rapport`);
export const regenererCleContrat = (id) => api.post(`/contracts/${id}/reset-key`);

// Sisco — Agent d'execution
export const siscoCommande = (commande) => api.post('/sisco/commande', { commande });
export const siscoAudit = (projetId) => api.post(`/sisco/audit/${projetId}`);
export const siscoAuditCommit = (data) => api.post('/sisco/audit-commit', data);
export const siscoReport = (format = 'json') => api.get(`/sisco/report?format=${format}`);
export const siscoStrategy = () => api.get('/sisco/strategy');
export const siscoUpdateStrategy = (data) => api.put('/sisco/strategy', data);
export const siscoLogs = (params) => api.get('/sisco/logs', { params });
export const siscoStatus = () => api.get('/sisco/status');

export default api;
